/** **   request.js   ****/
// 导入axios
import Vue from 'vue'
import axios from 'axios'
import { addNewColor } from '@ost/static'
import {Toast} from 'vant'
import store from '../store'
import router from '../router/index'
const SYSTEM_TYPE = '01'
// 使用element-ui Message做消息提醒
// import { Message} from 'ant-design-vue';
// 1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: '/api',
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 3 * 10000
  // headers: {
  //   'Content-Type': 'application/json;charset=UTF-8'
  // }
})

let timer = null
const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get('ACCESS_TOKEN')
    if (error.response.status === 403) {
      Toast.fail('你没有权限')
    }
    if (error.response.status === 401) {
      // Toast.fail('登录失效，请重新登录')
      if (timer) {
        clearTimeout(timer)
        timer = setTimeout(() => { Toast.fail('登录失效，请重新登录'); return true }, 500)
      } else {
        timer = setTimeout(() => { Toast.fail('登录失效，请重新登录'); return true }, 500)
      }
      Vue.ls.set('ACCESS_TOKEN', '')
      setTimeout(() => {
        window.location.reload()
      }, 600)
    }
    if (error.response.status === 412) {
      Toast.fail('The service is Lost')
    }
  }
  return Promise.reject(error)
}
service.interceptors.request.use(config => {
  // Toast.loading('加载中...')
  const token = Vue.ls.get('ACCESS_TOKEN')
  // console.log(config)
  if (store.state.user && store.state.user.token && token && store.state.user.token != token) {
    window.location.reload()
  }
  config.headers['Timestamp'] = '3.22.22'
  config.headers['current-systemtype'] = SYSTEM_TYPE
  config.headers['systemtype'] = SYSTEM_TYPE
  config.headers['platform'] = SYSTEM_TYPE
  config.headers['Accept-Language'] = 'zh-CN'
  config.headers['Content-Language'] = 'zh-CN'
  config.headers['request-platform'] = '00'
  config.headers['Accept-Language'] = 'zh-CN'
  config.headers['Content-Language'] = 'zh-CN'
  if (token) {
    config.headers['token'] = token
  }
  return addNewColor(config)
}, err)

service.interceptors.response.use(
  response => {
    return response.data
  }, err)
export function post (url, data, str, header) {
  let headers = {
    ...header
  }
  if (str && str == 'params') {
    let formData = new FormData()
    for (const key in data) {
      formData.append(key, data[key])
      headers = {
        processData: 'false',
        contentType: 'false',
        ...header
      }
    }
    data = formData
  }
  return new Promise((resolve, reject) => {
    service.post(url, data, {headers})
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

export function get (url, params) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export default {post, get, service}



// WEBPACK FOOTER //
// ./src/util/request.js